export const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;

// Wide enough for the location name plus one column per role without the grid
// scrolling sideways.
export const USER_FORM_MODAL_WIDTH = 720;

// qampo-ui-library's Checkbox puts its `id` on the wrapping label and looks it
// up with getElementById to tint the checkmark, so every instance on the page
// needs a unique id.
export const ACCOUNT_ADMIN_CHECKBOX_ID = 'user-account-admin';

export const buildUserRoleCheckboxId = (locationId: string, role: string): string =>
  `user-role-${locationId}-${role}`;
